import { ContentBlock } from '../content-choice';
import { CountryRiskProfile } from '../country-risk';

// TODO: This typeguard was written before the introduction of
// Commodity Risk related written content, it may have to be
// revisited

export function isCountryRiskProfile(block: ContentBlock): block is CountryRiskProfile {
  return Object.prototype.hasOwnProperty.call(block, 'country_code');
}
